import { render, staticRenderFns } from "./FormCreateDetailCustomerFile.vue?vue&type=template&id=67166bdf&scoped=true&"
import script from "./FormCreateDetailCustomerFile.vue?vue&type=script&lang=js&"
export * from "./FormCreateDetailCustomerFile.vue?vue&type=script&lang=js&"
import style0 from "./FormCreateDetailCustomerFile.vue?vue&type=style&index=0&id=67166bdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67166bdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VCol,VDialog,VIcon,VListItem,VListItemContent,VListItemTitle,VRow,VSelect,VTextField})
